'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactPortal = require('react-portal');

var _reactackleCore = require('reactackle-core');

var _TooltipStyled = require('./styles/TooltipStyled');

var _TooltipWrapperStyled = require('./styles/TooltipWrapperStyled');

var _TooltipContentStyled = require('./styles/TooltipContentStyled');

var _theme = require('./styles/theme');

var _theme2 = _interopRequireDefault(_theme);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

(0, _reactackleCore.registerDefaultComponentTheme)('tooltip', _theme2.default);
var propTypes = {
  /**
   * Text of the Tooltip
   */
  text: _propTypes2.default.string,

  /**
   * Determines x axis Tooltip position
   */
  positionX: _propTypes2.default.oneOf(['right', 'left']),

  /**
   * Determines y axis Tooltip position
   */
  positionY: _propTypes2.default.oneOf(['top', 'bottom']),

  /**
   * Determines whether Tooltip is visible
   */
  isVisible: _propTypes2.default.bool
};
var defaultProps = {
  text: '',
  positionX: 'right',
  positionY: 'bottom',
  isVisible: false
};

var Tooltip = function (_Component) {
  _inherits(Tooltip, _Component);

  function Tooltip(props) {
    _classCallCheck(this, Tooltip);

    var _this = _possibleConstructorReturn(this, (Tooltip.__proto__ || Object.getPrototypeOf(Tooltip)).call(this, props));

    _this.state = {
      positionX: void 0,
      positionY: void 0,
      top: 0,
      left: 0
    };
    _this._element = null;
    _this._createElementRef = _this._createElementRef.bind(_this);
    _this._setPosition = _this._setPosition.bind(_this);
    return _this;
  }

  _createClass(Tooltip, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      window.addEventListener('resize', this._setPosition);
      document.addEventListener('mousemove', this._setPosition);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this._setPosition);
      document.removeEventListener('mousemove', this._setPosition);
    }
  }, {
    key: '_setPosition',
    value: function _setPosition(_ref) {
      var _ref$clientX = _ref.clientX,
          left = _ref$clientX === undefined ? 0 : _ref$clientX,
          _ref$clientY = _ref.clientY,
          top = _ref$clientY === undefined ? 0 : _ref$clientY;
      if (!this._element || !this.props.isVisible) return;

      var _element$getBoundingC = this._element.getBoundingClientRect(),
          width = _element$getBoundingC.width,
          height = _element$getBoundingC.height;

      var positionX = void 0,
          positionY = void 0;
      if (left + width > document.body.clientWidth) positionX = 'left';else if (left < 0) positionX = 'right';
      if (top + height > document.body.clientHeight) positionY = 'top';else if (top < 0) positionY = 'bottom';
      this.setState({
        left: left,
        top: top,
        positionX: positionX,
        positionY: positionY
      });
    }
  }, {
    key: '_createElementRef',
    value: function _createElementRef(ref) {
      this._element = ref;
    }
  }, {
    key: 'render',
    value: function render() {
      var _state = this.state,
          left = _state.left,
          top = _state.top;
      return !this.props.isVisible ? null : _react2.default.createElement(_reactPortal.Portal, null, _react2.default.createElement(_TooltipWrapperStyled.TooltipWrapperStyled, {
        style: {
          left: left,
          top: top
        }
      }, _react2.default.createElement(_TooltipStyled.TooltipStyled, {
        innerRef: this._createElementRef,
        visible: this.props.isVisible,
        positionX: this.state.positionX || this.props.positionX,
        positionY: this.state.positionY || this.props.positionY
      }, _react2.default.createElement(_TooltipContentStyled.TooltipContentStyled, null, this.props.text))));
    }
  }]);

  return Tooltip;
}(_react.Component);

exports.default = Tooltip;
Tooltip.propTypes = propTypes;
Tooltip.defaultProps = defaultProps;
Tooltip.displayName = 'Tooltip';